export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/dashwebstudio',
  linkedin: 'https://linkedin.com/company/dashwebstudio',
  github: 'https://github.com/dashwebstudio',
  dribbble: 'https://dribbble.com/dashwebstudio'
};

export const META_TAGS = {
  home: {
    title: 'DashWeb Studio | Full Stack Development Agency',
    description: 'Professional digital solutions with cutting-edge technology. We specialize in React, Node.js, and Python development for enterprise-grade applications.',
    keywords: 'full stack development, web development, mobile apps, React, Node.js, Python, NestJS, Next.js'
  },
  work: {
    title: 'Our Work | DashWeb Studio',
    description: 'Explore our portfolio of successful projects and case studies showcasing our development expertise.',
    keywords: 'portfolio, case studies, web applications, mobile apps, e-commerce, dashboards'
  },
  services: {
    title: 'Our Services | DashWeb Studio',
    description: 'Comprehensive development services including frontend, backend, mobile, and DevOps solutions.',
    keywords: 'web development services, mobile development, consulting, UI/UX design, cloud solutions'
  },
  about: {
    title: 'About Us | DashWeb Studio',
    description: 'Learn about our team, methodology, and commitment to delivering high-quality digital solutions.',
    keywords: 'about us, our team, development process, company culture, methodology'
  },
  contact: {
    title: 'Contact Us | DashWeb Studio',
    description: 'Get in touch to discuss your project requirements and how we can help bring your vision to life.',
    keywords: 'contact, get a quote, consultation, project inquiry, support'
  }
};

export const TECH_STACK = [
  'React',
  'Next.js',
  'Node.js',
  'Python',
  'TypeScript',
  'NestJS',
  'PostgreSQL',
  'MongoDB',
  'AWS',
  'Docker',
  'React Native',
  'GraphQL',
  'Redux',
  'Jest',
  'Cypress'
];


// src/utils/constants.js
export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "High-performance online store with real-time analytics",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["React JS", "Node.js", "MongoDB"],
    details: [
      "Built a scalable e-commerce platform with real-time inventory management",
      "Implemented payment processing and analytics dashboard", 
      "Server-side rendering for SEO optimization and fast initial load times",
      "Real-time inventory tracking and automated reorder alerts",
      "Multi-payment gateway integration with fraud detection"
    ],
    challenge: "The client needed a comprehensive e-commerce solution that could handle high traffic volumes while providing real-time analytics and inventory management. The existing system was slow and couldn't scale with their growing customer base.",
    solution: "We developed a modern, scalable platform using React for the frontend and Node.js for the backend, with MongoDB for flexible data storage. We implemented server-side rendering for better SEO and faster initial load times, along with a comprehensive analytics dashboard.",
    results: [
      "40% increase in conversion rates",
      "60% faster page load times", 
      "99.9% uptime achieved",
      "50% reduction in cart abandonment"
    ],
    client: "TechCorp Solutions",
    duration: "6 months",
    team: "5 developers"
  },
  {
    id: 2,
    title: "Data Analytics Dashboard",
    description: "Interactive visualization platform for business intelligence",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1115&q=80",
    tags: ["React", "Python", "PostgreSQL"],
    details: [
      "Custom data visualization platform processing millions of data points",
      "Real-time data processing and visualization",
      "Custom charting components built from scratch", 
      "Data export functionality in multiple formats",
      "Role-based access control and user management"
    ],
    challenge: "The organization was struggling with disparate data sources and needed a unified platform to visualize complex business metrics in real-time for different stakeholder groups.",
    solution: "We created a comprehensive dashboard using React for interactive visualizations and Python for data processing. The system integrates with multiple data sources and provides role-based access to different metrics and reports.",
    results: [
      "Reduced reporting time by 80%",
      "Increased data accuracy by 95%",
      "Served 10M+ data points daily", 
      "Improved decision-making speed by 3x"
    ],
    client: "DataFlow Analytics",
    duration: "8 months", 
    team: "7 developers"
  },
  {
    id: 3,
    title: "Enterprise CMS",
    description: "Custom content management system for large organizations",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["React", "Node.js", "AWS"],
    details: [
      "Headless CMS with multi-tenant architecture",
      "Support for 50+ custom content types",
      "Advanced workflow management system",
      "AWS integration for scalability and reliability", 
      "API-first design for maximum flexibility"
    ],
    challenge: "A large enterprise needed a flexible content management system that could serve multiple brands and websites while maintaining security and scalability across different teams and workflows.",
    solution: "We built a headless CMS with a multi-tenant architecture that allows different organizations to manage their content independently while sharing infrastructure. The system integrates with AWS for automatic scaling and reliability.",
    results: [
      "Managed 100+ websites simultaneously",
      "Reduced content publishing time by 70%",
      "99.99% uptime with AWS integration",
      "Supported 500+ concurrent users"
    ],
    client: "Global Media Corp",
    duration: "10 months",
    team: "8 developers"
  },
  {
    id: 4,
    title: "Mobile Banking App", 
    description: "Secure financial application with biometric authentication",
    image: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["React Native", "Node.js", "Firebase"],
    details: [
      "Cross-platform mobile banking application",
      "Money transfers and bill payment functionality",
      "Investment tracking and portfolio management",
      "End-to-end encryption for all transactions",
      "Biometric authentication (fingerprint & face ID)"
    ],
    challenge: "The bank needed a secure, user-friendly mobile application that could handle sensitive financial transactions while providing a seamless user experience across iOS and Android platforms.",
    solution: "We developed a React Native application with robust security features including end-to-end encryption and biometric authentication. The backend uses Node.js with Firebase for real-time data synchronization and secure user management.",
    results: [
      "1M+ app downloads in first year",
      "Zero security breaches reported",
      "4.8/5 app store rating",
      "60% increase in mobile transactions"
    ],
    client: "SecureBank Financial",
    duration: "12 months", 
    team: "6 developers"
  },
  {
    id: 5,
    title: "Healthcare Portal",
    description: "Patient management system with telemedicine capabilities", 
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    tags: ["Angular", "NestJS", "MongoDB"],
    details: [
      "HIPAA-compliant healthcare portal",
      "Patient records management system",
      "Appointment scheduling and management",
      "Video consultation capabilities",
      "Integration with existing EHR systems and payment gateways"
    ],
    challenge: "A healthcare provider needed a comprehensive portal that could manage patient records, enable telemedicine consultations, and integrate with existing healthcare systems while maintaining HIPAA compliance.",
    solution: "We built a secure, HIPAA-compliant portal using Angular and NestJS that integrates seamlessly with existing EHR systems. The platform includes video consultation features and secure payment processing.",
    results: [
      "Served 50K+ patients",
      "Reduced appointment no-shows by 35%", 
      "Increased patient satisfaction by 45%",
      "100% HIPAA compliance maintained"
    ],
    client: "MedCare Health Systems",
    duration: "14 months",
    team: "9 developers"
  },
  {
    id: 6,
    title: "IoT Dashboard",
    description: "Real-time monitoring for industrial IoT devices",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80", 
    tags: ["React", "Python", "MQTT"],
    details: [
      "Real-time monitoring of industrial IoT devices",
      "Historical data analysis and reporting",
      "Alert system for device anomalies",
      "Support for thousands of concurrent device connections",
      "Minimal latency data processing and visualization"
    ],
    challenge: "An industrial company needed a solution to monitor thousands of IoT devices in real-time, with the ability to quickly identify issues and analyze historical trends for predictive maintenance.",
    solution: "We created a robust dashboard using React for the frontend and Python with MQTT for device communication. The system can handle thousands of concurrent connections with real-time data processing and alerting.",
    results: [
      "Monitored 10K+ devices simultaneously",
      "Reduced downtime by 50%",
      "99% alert accuracy achieved", 
      "Sub-second data processing latency"
    ],
    client: "IndustrialTech Manufacturing",
    duration: "9 months",
    team: "6 developers"
  }
];

export const services = [
  {
    id: 0,
    title: "Frontend Development",
    description: "Building responsive, accessible user interfaces with React. We focus on performance optimization, state management, and seamless user experiences.",
    image: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["React JS ", "Next.js ", "TypeScript "],
    details: [
      "Custom React component development with modern hooks and patterns",
      "Performance optimization through code splitting and lazy loading",
      "Accessibility (a11y) compliance ensuring inclusive user experiences",
      "Advanced state management with Redux, Zustand, or Context API",
      "Server-side rendering (SSR) and static generation with Next.js",
      "Progressive Web App (PWA) implementation",
      "Cross-browser compatibility and responsive design"
    ],
    challenge: "Modern web applications require exceptional user experiences with fast loading times, seamless interactions, and accessibility for all users. Companies struggle with maintaining performance while adding complex features and ensuring their applications work across all devices and browsers.",
    solution: "We leverage cutting-edge frontend technologies and best practices to create high-performance, accessible web applications. Our approach includes component-driven development, performance monitoring, and comprehensive testing to ensure reliability and user satisfaction.",
    benefits: [
      "Faster time-to-market with reusable component libraries",
      "Improved SEO rankings through optimized performance",
      "Enhanced user engagement with smooth, responsive interfaces",
      "Reduced maintenance costs through clean, maintainable code",
      "Better accessibility compliance reducing legal risks"
    ],
    process: [
      "Requirements analysis and technical planning",
      "UI/UX design review and component architecture",
      "Iterative development with regular client feedback",
      "Performance optimization and accessibility testing",
      "Deployment and ongoing maintenance support"
    ],
    technologies: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "React Query", "Vite", "Jest"]
  },
  {
    id: 1,
    title: "Backend Development",
    description: "Scalable server-side solutions with Node.js and Python. We implement RESTful APIs, GraphQL, and microservices architectures for your business logic.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["Node.js", "Python", "PostgreSQL"],
    details: [
      "RESTful API development with comprehensive documentation",
      "GraphQL implementation for flexible data fetching",
      "Database design and optimization for performance",
      "Authentication and authorization with JWT and OAuth",
      "Microservices architecture for scalable applications",
      "Real-time communication with WebSockets and Server-Sent Events",
      "Background job processing and queue management"
    ],
    challenge: "Backend systems need to handle increasing loads while maintaining security, reliability, and performance. Organizations require robust APIs that can scale with their business growth and integrate with various third-party services seamlessly.",
    solution: "We design and implement scalable backend architectures using modern frameworks and cloud technologies. Our solutions focus on security, performance, and maintainability while providing the flexibility to adapt to changing business requirements.",
    benefits: [
      "Scalable architecture that grows with your business",
      "Robust security measures protecting sensitive data",
      "High-performance APIs with optimized response times",
      "Easy integration with third-party services and APIs",
      "Comprehensive monitoring and error tracking"
    ],
    process: [
      "System architecture design and database modeling",
      "API development with security and validation",
      "Integration testing and performance optimization",
      "Documentation and deployment automation",
      "Monitoring setup and maintenance protocols"
    ],
    technologies: ["Node.js", "Python", "PostgreSQL", "MongoDB", "Redis", "Docker", "AWS", "GraphQL"]
  },
  {
    id: 2,
    title: "Mobile Development",
    description: "Cross-platform mobile applications with React Native and Flutter. We deliver native-like performance with shared codebase for iOS and Android.",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["Flutter", "Dart", "Firebase"],
    details: [
      "Cross-platform mobile app development",
      "Native module integration for platform-specific features",
      "Offline-first capabilities with local data storage",
      "Push notifications and real-time messaging",
      "App store optimization and deployment",
      "Performance monitoring and crash reporting",
      "Biometric authentication and security features"
    ],
    challenge: "Mobile app development traditionally requires separate teams for iOS and Android, leading to increased costs and longer development cycles. Apps need to perform well on various devices while providing native-like user experiences.",
    solution: "We use cross-platform frameworks like React Native and Flutter to develop high-quality mobile applications with a single codebase. This approach reduces development time and costs while maintaining native performance and user experience.",
    benefits: [
      "50% reduction in development time and costs",
      "Consistent user experience across platforms",
      "Faster feature rollouts and updates",
      "Easy maintenance with unified codebase",
      "Access to native device features and performance"
    ],
    process: [
      "Mobile strategy consultation and platform selection",
      "UI/UX design optimized for mobile interactions",
      "Cross-platform development with native integrations",
      "Testing on multiple devices and OS versions",
      "App store submission and ongoing updates"
    ],
    technologies: ["React Native", "Flutter", "Dart", "Firebase", "Redux", "Expo", "Fastlane", "CodePush"]
  },
  {
    id: 3,
    title: "DevOps & Security",
    description: "Secure deployment pipelines and infrastructure management. We implement CI/CD, monitoring, and security best practices for your applications.",
    image: "https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["Docker", "AWS", "Security"],
    details: [
      "CI/CD pipeline setup with automated testing and deployment",
      "Containerization with Docker and Kubernetes orchestration",
      "Cloud infrastructure setup and management (AWS, GCP, Azure)",
      "Security audits and penetration testing",
      "Infrastructure as Code (IaC) with Terraform",
      "Monitoring, logging, and alerting systems",
      "Backup and disaster recovery planning"
    ],
    challenge: "Organizations need reliable, secure, and scalable infrastructure that can handle varying loads while maintaining high availability. Manual deployment processes are error-prone and slow, while security vulnerabilities can lead to costly breaches.",
    solution: "We implement robust DevOps practices with automated CI/CD pipelines, containerized deployments, and comprehensive security measures. Our infrastructure solutions are designed for scalability, reliability, and cost-effectiveness.",
    benefits: [
      "99.9% uptime with automated failover systems",
      "Faster deployment cycles with reduced human error",
      "Enhanced security with continuous monitoring",
      "Cost optimization through efficient resource usage",
      "Scalable infrastructure that adapts to demand"
    ],
    process: [
      "Infrastructure assessment and migration planning",
      "CI/CD pipeline design and implementation",
      "Security audit and compliance setup",
      "Monitoring and alerting configuration",
      "Team training and documentation"
    ],
    technologies: ["Docker", "Kubernetes", "AWS", "Terraform", "Jenkins", "GitLab CI", "Prometheus", "ELK Stack"]
  },
  {
    id: 4,
    title: "Technical Consulting",
    description: "Expert guidance on architecture, technology selection, and development processes to ensure your project's success.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["Architecture", "Code Review", "Mentoring"],
    details: [
      "System architecture design and technology selection",
      "Code reviews and quality assessments",
      "Performance optimization and scalability planning",
      "Team mentoring and technical training",
      "Project rescue and legacy system modernization",
      "Technical debt assessment and remediation",
      "Best practices implementation and process improvement"
    ],
    challenge: "Technical teams often face challenges with architecture decisions, code quality, and scaling issues. Without proper guidance, projects can become costly to maintain and difficult to scale, leading to technical debt and performance problems.",
    solution: "Our experienced consultants provide strategic technical guidance to help teams make informed decisions about architecture, technology selection, and development processes. We focus on long-term sustainability and scalability.",
    benefits: [
      "Reduced technical debt and maintenance costs",
      "Improved team productivity and code quality",
      "Better architectural decisions for long-term success",
      "Enhanced development processes and practices",
      "Risk mitigation through expert oversight"
    ],
    process: [
      "Technical assessment and gap analysis",
      "Architecture review and recommendations",
      "Team workshops and knowledge transfer",
      "Implementation guidance and monitoring",
      "Ongoing support and optimization"
    ],
    technologies: ["Various", "Architecture Patterns", "Design Principles", "Code Analysis Tools", "Documentation"]
  },
  {
    id: 5,
    title: "UI/UX Design",
    description: "User-centered design solutions that combine aesthetics with functionality to create engaging digital experiences.",
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
    tags: ["Figma", "Prototyping", "User Testing"],
    details: [
      "User research and persona development",
      "Information architecture and user journey mapping",
      "Wireframing and interactive prototyping",
      "Visual design and brand integration",
      "Design system creation and maintenance",
      "Usability testing and iteration",
      "Accessibility-focused design principles"
    ],
    challenge: "Many digital products fail because they don't meet user needs or provide poor user experiences. Companies struggle to balance business requirements with user expectations while ensuring their products are accessible and engaging.",
    solution: "We follow a user-centered design process that combines research, design, and testing to create intuitive and engaging digital experiences. Our approach ensures that design decisions are based on user needs and business objectives.",
    benefits: [
      "Increased user engagement and satisfaction",
      "Higher conversion rates and business metrics",
      "Reduced development costs through early validation",
      "Improved accessibility and inclusivity",
      "Stronger brand identity and user loyalty"
    ],
    process: [
      "User research and requirements gathering",
      "Concept development and wireframing",
      "Visual design and prototyping",
      "User testing and feedback incorporation",
      "Design system documentation and handoff"
    ],
    technologies: ["Figma", "Adobe Creative Suite", "Sketch", "InVision", "Miro", "Hotjar", "UsabilityHub"]
  }
];